import { Search } from "flowbite-react-icons/outline";

interface SearchBarProps {
  onSearch?: (value: string) => void;
}

export default function SearchBar({ onSearch }: SearchBarProps) {
  function handleSearch(event: React.ChangeEvent<HTMLInputElement>) {
    const searchValue = event.target.value;
    if (onSearch) {
      onSearch(searchValue);
    }
  }

  return (
    <fieldset className="input flex items-center gap-2">
      <input
        onChange={handleSearch}
        type="text"
        className="grow global-search-input"
        placeholder="Search"
      />
      <Search />
    </fieldset>
  );
}
